//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import ContactUtils from '../../../utils/contact';
var getPropVal = ContactUtils.getPropVal;
/**
 * @typedef { object } AccountModel Data model returned by the sever representing an Account.
 * @property { number } Id Account unique identifier.
 * @property { object[] } Properties Account properties.
 * @property { { Name: string } } AccountType Account type.
 * */

/**@type {import('../types').DataType<AccountModel>} */

var ACCOUNT_DATA_TYPE = {
  data: {
    url: '/backend/accounts',
    dataKey: 'accounts',
    idKeyProp: 'Id'
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "account",
        data: data
      });
    },
    serverSort: true //inMemorySort: data => getPropVal(data, 'Name'),

  }, {
    id: 'Type',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.AccountType.Name
      });
    } //inMemorySort: data => getPropVal(data, 'Type'),

  }, {
    id: 'State',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        value: getPropVal(data, 'State')
      });
    } //inMemorySort: data => getPropVal(data, 'State'),

  }],
  thumbnail: {
    text: function text(data) {
      return getPropVal(data, 'Name');
    },
    icon: function icon() {
      return 'account';
    }
  },
  placeholders: {
    label: function label(data) {
      return getPropVal(data, 'Name');
    },
    type: function type() {
      return 'account';
    },
    icon: function icon() {
      return 'account';
    }
  },
  contextMenu: [{
    type: 'delete'
  }]
};
export default ACCOUNT_DATA_TYPE;